/**
 * Variant Image Manager for CarOptions (v4)
 * Handles variant image show/hide for Kalles 4.1.3 theme
 * - Updates is--media-hide on main slides AND thumbnail nav items
 * - Uses Kalles carousel instance (element.flickityt4s) for proper gallery refresh
 * - Finds the correct cell index for the variant image (not hardcoded 0)
 */
(function() {
  'use strict';

  function getVariantMediaMap() {
    var map = {};
    var allIds = [];
    document.querySelectorAll('select[name="id"] option').forEach(function(opt) {
      var mdid = opt.getAttribute('data-mdid');
      if (mdid && mdid !== 'null' && mdid !== '') {
        map[opt.value] = mdid;
        if (allIds.indexOf(mdid) === -1) allIds.push(mdid);
      }
    });
    return { variantToMedia: map, allVariantMediaIds: allIds };
  }

  function findCellIndex(kc, mediaId) {
    if (!mediaId || !kc.$carousel) return 0;
    var flkty = kc.$carousel.data('flickityt4s');
    if (!flkty || !flkty.cells) return 0;
    for (var i = 0; i < flkty.cells.length; i++) {
      if (flkty.cells[i].element.getAttribute('data-media-id') === mediaId) {
        return i;
      }
    }
    return 0;
  }

  function navigateToCell(kc, cellIndex) {
    try {
      kc.$carousel.flickityt4s('select', cellIndex, false, true);
      if (typeof kc.thumbnailsGoto === 'function') {
        kc.thumbnailsGoto(cellIndex);
      }
    } catch(e) {}
  }

  var variantSelectionScroll = null;

  function rememberVariantSelectionScroll(event) {
    if (!event.target || !event.target.closest) return;
    var dropdownButton = event.target.closest('[data-dropdown-open]');
    var swatchItem = event.target.closest('[data-swatch-item]');
    if (!dropdownButton && !swatchItem) return;
    if (swatchItem && variantSelectionScroll && Date.now() - variantSelectionScroll.capturedAt < 1000) return;
    variantSelectionScroll = {
      left: window.scrollX,
      top: window.scrollY,
      capturedAt: Date.now()
    };
  }

  function restoreScrollPosition(left, top) {
    var restore = function() {
      if (Math.abs(window.scrollX - left) > 1 || Math.abs(window.scrollY - top) > 1) {
        window.scrollTo(left, top);
      }
    };
    restore();
    if (window.requestAnimationFrame) window.requestAnimationFrame(restore);
    setTimeout(restore, 80);
    setTimeout(restore, 250);
    setTimeout(restore, 500);
  }

  function filterEuProfileMedia(selectedVariantId) {
    var changed = false;
    document.querySelectorAll('[data-co-eu-media-route]').forEach(function(route) {
      var slide = route.closest('.t4s-product__media-item');
      if (!slide) return;
      var variantIds = (route.getAttribute('data-co-eu-variant-ids') || '').split(',');
      var visible = variantIds.indexOf(String(selectedVariantId)) !== -1;
      var hidden = slide.classList.contains('is--media-hide');
      if (visible && hidden) {
        slide.classList.remove('is--media-hide');
        changed = true;
        slide.querySelectorAll('img.lazyloadt4s').forEach(function(img) {
          img.classList.add('lazypreloadt4s');
          if (window.lazySizes) lazySizes.loader.unveil(img);
        });
      } else if (!visible && !hidden) {
        slide.classList.add('is--media-hide');
        changed = true;
      }
      slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
    });
    return changed;
  }

  function filterVariantMedia(selectedVariantId) {
    var scrollLeftBefore = window.scrollX;
    var scrollTopBefore = window.scrollY;
    if (variantSelectionScroll && Date.now() - variantSelectionScroll.capturedAt < 1000) {
      scrollLeftBefore = variantSelectionScroll.left;
      scrollTopBefore = variantSelectionScroll.top;
    }
    var data = getVariantMediaMap();
    var selectedMediaId = data.variantToMedia[selectedVariantId] || null;
    var allVariantMediaIds = data.allVariantMediaIds;
    var changed = filterEuProfileMedia(selectedVariantId);
    if (allVariantMediaIds.length === 0 && !changed) return;

    // 0. Remove any display:none CSS from the old inline updateCSS script
    var viHide = document.getElementById('vi-hide');
    if (viHide) viHide.textContent = '';

    // 1. Update is--media-hide on main slides
    allVariantMediaIds.forEach(function(mediaId) {
      var slides = document.querySelectorAll('[data-main-slide][data-media-id="' + mediaId + '"]');
      slides.forEach(function(el) {
        if (mediaId === selectedMediaId) {
          if (el.classList.contains('is--media-hide')) {
            el.classList.remove('is--media-hide');
            changed = true;
            el.querySelectorAll('img.lazyloadt4s').forEach(function(img) {
              img.classList.add('lazypreloadt4s');
              if (window.lazySizes) lazySizes.loader.unveil(img);
            });
          }
        } else {
          if (!el.classList.contains('is--media-hide')) {
            el.classList.add('is--media-hide');
            changed = true;
          }
        }
      });
    });

    if (!changed) return;

    // 2. Find the Kalles carousel instance
    var galleryEl = document.querySelector('.flickityt4s[data-main-media]');
    if (!galleryEl || !galleryEl.flickityt4s) {
      restoreScrollPosition(scrollLeftBefore, scrollTopBefore);
      return;
    }
    var kc = galleryEl.flickityt4s;

    // 3. Rebuild thumbnail nav
    if (typeof kc.thumbnailsMarkup === 'function') {
      kc.thumbnailsMarkup();
    }

    // 4. Deactivate + activate Flickity to rebuild cells
    if (kc.$carousel && kc.$carousel.flickityt4s) {
      kc.$carousel.flickityt4s('deactivate').flickityt4s('activate');
      setTimeout(function() {
        var idx = findCellIndex(kc, selectedMediaId);
        navigateToCell(kc, idx);
      }, 50);
    }
    restoreScrollPosition(scrollLeftBefore, scrollTopBefore);
  }

  function init() {
    document.addEventListener('pointerdown', rememberVariantSelectionScroll, true);
    document.querySelectorAll('select[name="id"]').forEach(function(select) {
      select.addEventListener('change', function() {
        filterVariantMedia(select.value);
      });
    });

    document.addEventListener('variant:changed', function(e) {
      if (e.detail && e.detail.variant) {
        filterVariantMedia(String(e.detail.variant.id));
      }
    });
  }

  function preloadVariantImages() {
    var data = getVariantMediaMap();
    data.allVariantMediaIds.forEach(function(mediaId) {
      var slide = document.querySelector('[data-main-slide][data-media-id="' + mediaId + '"]');
      if (!slide) return;
      slide.querySelectorAll('img.lazyloadt4s').forEach(function(img) {
        img.classList.add('lazypreloadt4s');
        if (window.lazySizes) lazySizes.loader.unveil(img);
      });
    });
  }

  function initialSync() {
    var select = document.querySelector('select[name="id"]');
    if (!select) return;
    filterVariantMedia(select.value);
    var opt = select.querySelector('option:checked');
    var mediaId = opt ? opt.getAttribute('data-mdid') : null;

    var galleryEl = document.querySelector('.flickityt4s[data-main-media]');
    if (!galleryEl || !galleryEl.flickityt4s) return;
    var kc = galleryEl.flickityt4s;
    if (!kc.$carousel) return;

    var idx = findCellIndex(kc, mediaId);
    var flkty = kc.$carousel.data('flickityt4s');
    if (flkty && idx !== flkty.selectedIndex) {
      navigateToCell(kc, idx);
    }
  }

  if (document.readyState === 'complete') {
    setTimeout(function() { init(); preloadVariantImages(); initialSync(); }, 300);
  } else {
    window.addEventListener('load', function() {
      setTimeout(function() { init(); preloadVariantImages(); initialSync(); }, 300);
    });
  }
})();
